const awsmobile = {
    "aws_project_region": "us-west-2", // The region your project is deployed in
    "aws_appsync_graphqlEndpoint": "https://qbrf76dvsfaovbechx6hzuo4cu.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-6bg4ga2cpbcijlittircjtorty" // Replace with your actual API key
};

export default awsmobile;